import momentApi from '../apis/moments'

const state = {
  currentTabIndex: 1,
  momentList: [
    // {
    //   category: '',
    //   data: [],
    //   total: 0,
    //   currentPage: 1,
    //   lastPage: 1,
    //   loading: false,
    //   maxMomentId: ''
    // },
    {
      category: 'trace',
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false
    },
    {
      category: 'hot',
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false
    },
    {
      category: 'commonweal',
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false
    },
    {
      category: 'official',
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false
    },
    {
      hashTagId: 1,
      category: '',
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false
    },
    {
      hashTagId: 2,
      category: '',
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false
    },
    {
      hashTagId: 3,
      category: '',
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false
    },
    {
      hashTagId: 4,
      category: '',
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false
    },
    {
      hashTagId: 5,
      category: '',
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false
    }
  ],
  momentDetail: {
    comment_count: 0,
    content: '',
    created_at: '',
    id: 0,
    images: [],
    is_like: false,
    like_count: 0,
    object_id: 0,
    object: {},
    recent_comments: [],
    recent_moment_likes: [],
    type: 'normal',
    user: {},
    user_id: 0,
    at_users: []
  },
  // 詳情頁面的留言列表
  momentLikes: {
    momentId: 0,
    loading: false,
    currentPage: 1,
    lastPage: 1,
    total: 0,
    data: []
  },
  momentComments: {
    momentId: 0,
    loading: false,
    currentPage: 1,
    lastPage: 1,
    total: 0,
    data: []
  },
  newMoment: {
    content: '',
    images: [],
    tags: [],
    object: {},
    type: 'normal',
    atUsers: []
  },
  userMoments: {
    data: [],
    total: 0,
    currentPage: 1,
    lastPage: 1,
    userId: 0,
    loading: false
  },
  momentCommentData: {
    content: '',
    atUsers: [],
    imgLists: []
  },
  recommendUsers: [],
  atUser: null // reminder禮物需求頁面sence下tag會員，（暫存，之後優化）
}

const actions = {
  getMomentList ({ commit, state }, { maxMomentId, category, hashTagId, page, tabIndex }) {
    commit('setMomentLoading', { tabIndex, loading: true })
    return momentApi.getMomentList(category, hashTagId, page, maxMomentId)
      .then((data) => {
        commit('setMomentList', { tabIndex, data })
      })
  },
  publishMoment ({ commit, state }, {content, images, hash_tags: tags, type, object_id: objectId, video, at_users: atUsers}) {
    return momentApi.publishMoment(content, images, type, objectId, tags, atUsers, video)
      .then((data) => {
        commit('addNewMoment', { data: data.data.moment })
      })
  },
  updateMoment ({ commit, state }, { momentId, data }) {
    return momentApi.updateMoment(momentId, data)
      .then((data) => {
        commit('updateMoment', { data: data.data.moment })
      })
  },
  getMomentDetail ({ commit, state }, { momentId }) {
    let moment = state.momentList[0].data.find(item => item.id === momentId)
    if (!moment) {
      moment = state.userMoments.data.find(item => item.id === momentId)
    }
    if (moment) {
      commit('setMomentDetail', { data: moment })
      return new Promise((resolve) => {
        resolve(moment)
      })
    }

    return momentApi.getMomentDetail(momentId)
      .then(data => {
        commit('setMomentDetail', { data })
        return data
      })
  },
  likeMoment ({ commit, state }, { momentId, user, isLike = true }) {
    return momentApi.like(momentId, isLike)
      .then((data) => {
        if (isLike) {
          commit('setMomentLike', {momentId, user})
        } else {
          commit('cancelLike', {momentId, user})
        }
        return data
      })
  },
  commentMoment ({ commit, state }, { momentId, content, image, atUsers }) {
    let atUserIds = []
    for (let user of atUsers) {
      atUserIds.push(user.id)
    }
    return momentApi.comment(momentId, content, image, atUserIds)
      .then(res => {
        commit('addMomentComment', {momentId, momentComment: res.data.momentComment})
      })
  },
  replyMomentComment ({ commit, state }, { momentId, content, image, replyToUserId, atUsers }) {
    let atUserIds = []
    for (let user of atUsers) {
      atUserIds.push(user.id)
    }
    return momentApi.replyComment(momentId, content, image, replyToUserId, atUserIds)
      .then(res => {
        commit('addMomentComment', {momentId, momentComment: res.data.momentComment})
      })
  },
  getUserMomentList ({commit, state}, {userId, page}) {
    commit('setUserMomentLoading', {loading: true})
    return momentApi.getUserMomentList(userId, page)
      .then(data => {
        commit('setUserMomentList', {userId, data})
      })
  },
  getMomentCommentList ({commit, state}, {momentId, page}) {
    commit('setMomentCommentsLoading', {loading: true})
    return momentApi.getMomentCommentList(momentId, page)
      .then(data => {
        commit('setMomentCommentsList', {momentId, data})
        return data
      })
  },
  deleteMoment ({commit, state}, {momentId}) {
    return momentApi.deleteMoment(momentId)
      .then(res => {
        commit('removeMoment', {momentId})
        if (state.momentDetail.id === momentId) {
          commit('resetMomentDetail')
        }
      })
  },
  deleteMomentComment ({commit, state}, {momentId, commentId}) {
    return momentApi.deleteComment(commentId)
      .then(res => {
        commit('removeMomentComment', {momentId, commentId})
      })
  },
  getMomentLikes ({commit}, {momentId, page}) {
    commit('setMomentLikesLoading', {loading: true})
    return momentApi.getMomentLikeList(momentId, page)
      .then(data => {
        commit('setMomentLikesList', {momentId, data})
      })
  },
  getMomentRecommendUsers ({commit}) {
    return momentApi.getMomentRecommendUsers()
      .then((res) => {
        commit('setMomentRecommendUsers', res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

const mutations = {
  setCurrentTabIndex (state, {index}) {
    state.currentTabIndex = index
  },
  setMomentList (state, {tabIndex, data}) {
    let list = state.momentList[tabIndex]
    state.momentList = [
      ...state.momentList
    ]
    if (tabIndex === 0 && data.current_page === 1 && data.data.length) {
      state.momentList[tabIndex].maxMomentId = data.maxMomentId || ''
    }
    state.momentList[tabIndex] = {
      ...list,
      total: data.total,
      lastPage: data.last_page,
      currentPage: data.current_page + 1,
      loading: false,
      data: data.current_page === 1 ? data.data : list.data.concat(data.data)
    }
  },
  setMomentLoading (state, {tabIndex, loading}) {
    state.momentList = [
      ...state.momentList
    ]
    state.momentList[tabIndex] = {
      ...state.momentList[tabIndex],
      loading
    }
  },
  setNewMoment (state, payload) {
    state.newMoment = {
      ...state.newMoment,
      ...payload
    }
  },
  addAtUser (state, { user, sence }) {
    if (sence === 'moment') {
      let newAtUsers = state.newMoment.atUsers
      newAtUsers.push(user)

      let content = state.newMoment.content
      if (content.length && content[content.length - 1] === '@') {
        content += user.nickname + ' '
      } else {
        content += '@' + user.nickname + ' '
      }
      state.newMoment = {
        ...state.newMoment,
        atUsers: newAtUsers,
        content
      }
    } else if (sence === 'moment_comment') {
      let newAtUsers = state.momentCommentData.atUsers
      newAtUsers.push(user)

      let content = state.momentCommentData.content
      if (content.length && content[content.length - 1] === '@') {
        content += user.nickname + ' '
      } else {
        content += '@' + user.nickname + ' '
      }
      state.momentCommentData = {
        ...state.momentCommentData,
        atUsers: newAtUsers,
        content
      }
    } else {
      state.atUser = user
    }
  },
  resetNewMoment (state) {
    state.newMoment = {
      content: '',
      images: [],
      tags: [],
      type: 'normal',
      object: {},
      atUsers: [],
      video: ''
    }
  },
  addNewMoment (state, { data }) {
    if (state.momentList[1].total) {
      data.recent_moment_likes = []
      data.recent_comments = []
      state.momentList = [
        ...state.momentList
      ]
      state.momentList[0].data.unshift(data)
      state.momentList[1].data.unshift(data)
    }

    if (data.user_id === state.userMoments.userId) {
      state.userMoments.data = [
        ...state.userMoments.data
      ]
      state.userMoments.data.unshift(data)
    }
  },
  updateMoment (state, { data }) {
    if (state.momentDetail && state.momentDetail.id === data.id) {
      state.momentDetail = {
        ...state.momentDetail,
        ...data
      }
    }

    for (let moments of state.momentList) {
      for (let i = 0; i < moments.data.length; ++i) {
        if (data.id === moments.data[i].id) {
          moments.data[i] = {
            ...moments.data[i],
            ...data
          }
          break
        }
      }
    }
    state.momentList = [...state.momentList]
  },
  setMomentDetail (state, { data }) {
    state.momentDetail = data
    // 預加載 使用詳情中的recent_comments
    if (data.recent_comments && state.momentComments.total === 0) {
      state.momentComments.data = [...data.recent_comments]
    }

    if (data.recent_moment_likes && state.momentLikes.total === 0) {
      state.momentLikes.data = [...data.recent_moment_likes]
    }
  },
  setMomentLike (state, { momentId, user }) {
    state.momentList = [
      ...state.momentList
    ]
    let find = false
    for (let moments of state.momentList) {
      let moment = moments.data.find(item => item.id === momentId)
      if (moment) {
        find = true
        moment.is_like = true
        moment.like_count += 1
        moment.recent_moment_likes.unshift({
          user,
          moment_id: momentId,
          user_id: user.id
        })
        moment.recent_moment_likes = [...moment.recent_moment_likes]
      }
    }
    if (!find && state.momentDetail.id === momentId) {
      state.momentDetail.is_like = true
      state.momentDetail.like_count += 1
      state.momentDetail.recent_moment_likes.unshift({
        user,
        moment_id: momentId,
        user_id: user.id
      })
    }
    if (state.momentLikes.momentId === momentId) {
      state.momentLikes.data.unshift({
        user,
        moment_id: momentId,
        user_id: user.id
      })
      state.momentLikes.total += 1
    }
  },
  cancelLike (state, { momentId, user }) {
    state.momentList = [
      ...state.momentList
    ]
    let find = false
    for (let moments of state.momentList) {
      let moment = moments.data.find(item => item.id === momentId)
      if (moment) {
        find = true
        moment.is_like = false
        moment.like_count -= 1
        let recentMomentLikes = moment.recent_moment_likes
        for (let index in recentMomentLikes) {
          if (recentMomentLikes[index].user_id === user.id) {
            recentMomentLikes.splice(index, 1)
            break
          }
        }
      }
    }
    if (!find && state.momentDetail.id === momentId) {
      state.momentDetail.is_like = false
      state.momentDetail.like_count -= 1
      let recentMomentLikes = state.momentDetail.recent_moment_likes
      for (let index in recentMomentLikes) {
        if (recentMomentLikes[index].user_id === user.id) {
          recentMomentLikes.splice(index, 1)
          break
        }
      }
    }

    if (state.momentLikes.momentId === momentId) {
      let likeList = state.momentLikes.data
      for (let i = 0; i < likeList.length; ++i) {
        if (likeList[i].user_id === user.id) {
          likeList.splice(i, 1)
          break
        }
      }
      state.momentLikes.total -= 1
    }
  },
  addMomentComment (state, { momentId, momentComment }) {
    state.momentList = [
      ...state.momentList
    ]
    for (let moments of state.momentList) {
      let moment = moments.data.find(item => item.id === momentId)
      if (moment) {
        moment.comment_count += 1
        let recentComments = [
          ...moment.recent_comments
        ]
        recentComments.push(momentComment)
        moment.recent_comments = recentComments
      }
    }
    if (state.momentComments.momentId === momentId) {
      let data = [...state.momentComments.data]
      data.push(momentComment)
      state.momentComments.data = data
      state.momentComments.total += 1
    }
  },
  resetUserMomentList (state) {
    state.userMoments = {
      data: [],
      total: 0,
      currentPage: 1,
      lastPage: 1,
      loading: false,
      userId: 0
    }
  },
  setUserMomentList (state, {userId, data}) {
    state.userMoments.userId = userId
    state.userMoments.currentPage = data.current_page + 1
    state.userMoments.total = data.total
    state.userMoments.lastPage = data.last_page
    state.userMoments.data = data.current_page === 1 ? data.data : state.userMoments.data.concat(data.data)
    state.userMoments.loading = false
  },
  setUserMomentLoading (state, {loading}) {
    state.userMoments.loading = loading
  },
  setMomentCommentsLoading (state, {loading}) {
    state.momentComments.loading = loading
  },
  setMomentCommentsList (state, {momentId, data}) {
    state.momentComments.momentId = momentId
    state.momentComments.currentPage = data.current_page + 1
    state.momentComments.total = data.total
    state.momentComments.lastPage = data.last_page
    state.momentComments.data = data.current_page === 1 ? data.data : state.momentComments.data.concat(data.data)
    state.momentComments.loading = false
  },
  setMomentLikesLoading (state, {loading}) {
    state.momentLikes.loading = loading
  },
  setMomentLikesList (state, {momentId, data}) {
    state.momentLikes.momentId = momentId
    state.momentLikes.currentPage = data.current_page + 1
    state.momentLikes.total = data.total
    state.momentLikes.lastPage = data.last_page
    state.momentLikes.data = data.current_page === 1 ? data.data : state.momentLikes.data.concat(data.data)
    state.momentLikes.loading = false
  },
  resetMomentDetail (state) {
    state.momentDetail = {
      comment_count: 0,
      content: '',
      created_at: '',
      id: 0,
      images: [],
      is_like: false,
      like_count: 0,
      object_id: 0,
      object: {},
      recent_comments: [],
      recent_moment_likes: [],
      type: 'normal',
      user: {},
      user_id: 0,
      at_users: []
    }
    state.momentComments = {
      momentId: 0,
      loading: false,
      currentPage: 1,
      lastPage: 1,
      total: 0,
      data: []
    }
    state.momentLikes = {
      momentId: 0,
      loading: false,
      currentPage: 1,
      lastPage: 1,
      total: 0,
      data: []
    }
  },
  removeMoment (state, {momentId}) {
    state.momentList = [
      ...state.momentList
    ]
    for (let moments of state.momentList) {
      for (let i = 0; i < moments.data.length; ++i) {
        if (moments.data[i].id === momentId) {
          moments.data.splice(i, 1)
          moments.total -= 1
          break
        }
      }
    }
    for (let i = 0; i < state.userMoments.data.length; ++i) {
      if (state.userMoments.data[i].id === momentId) {
        state.userMoments.data.splice(i, 1)
        state.userMoments.total -= 1
        break
      }
    }
  },
  removeMomentComment (state, {momentId, commentId}) {
    state.momentList = [
      ...state.momentList
    ]
    let bFind = false
    for (let moments of state.momentList) {
      let moment = moments.data.find(item => item.id === momentId)
      if (moment) {
        let recentComments = moment.recent_comments
        for (let i = 0; i < recentComments.length; ++i) {
          if (recentComments[i].id === commentId) {
            recentComments.splice(i, 1)
            moment.recent_comments = [...recentComments]
            moment.comment_count -= 1
            bFind = true
            break
          }
        }
      }
    }

    if (state.momentDetail.id === momentId) {
      if (!bFind) { // 如果列表減了留言數量，則這裡沒有必要再減少
        state.momentDetail = {
          ...state.momentDetail,
          comment_count: state.momentDetail.comment_count - 1
        }
      }
      let commentList = state.momentComments.data
      for (let i = 0; i < commentList.length; ++i) {
        if (commentList[i].id === commentId) {
          commentList.splice(i, 1)
          break
        }
      }
      state.momentComments = {
        ...state.momentComments,
        total: state.momentComments.total - 1
      }
    }
  },
  setMomentCommentData (state, payload) {
    state.momentCommentData = {
      ...state.momentCommentData,
      ...payload
    }
  },
  clearMomentCommentData (state) {
    state.momentCommentData = {
      content: '',
      atUsers: [],
      imgLists: []
    }
  },
  clearAtUser (state) {
    state.atUser = null
  },
  setMomentRecommendUsers (state, data) {
    state.recommendUsers = data
  },
  setRecommendUserTraced (state, data) {
    state.recommendUsers.map(item => {
      if (item.id === data.userId) {
        item.is_tracing = true
      }
    })
    state.recommendUsers = [...state.recommendUsers]
  }
}

export default {
  state,
  actions,
  mutations
}
